export default __webpack_public_path__ + "static/media/Icon-awesome-eye-slash.c9646b89.svg";